export const defaultValue = () => {
  return JSON.parse(
    JSON.stringify({
      content: '',
      style: {
        backgroundColor: '',
        textAlign: '',
        width: '',
        height: '',
        paddingTop: 15,
        paddingRight: 10,
        paddingBottom: 15,
        paddingLeft: 10
      }
    })
  )
}
